<template>
  <v-container
    class="fill-height"
    v-if="currentPermission.privilegeLevel != 'admin'"
  >
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="5">
        <AccessDeniedCard />
      </v-col>
    </v-row>
  </v-container>
  <v-container v-else fluid>
    <v-row align="center" justify="center" class="mx-0">
      <v-col cols="12">
        <v-breadcrumbs :items="breadcrumbItems" large></v-breadcrumbs>
      </v-col>
      <!-- <v-col cols="12">
        <div class="text-h5">Manage Billing</div>
      </v-col> -->
      <!-- <v-col cols="12">
        <v-card outlined>
          <v-card-title>
            Payment Method
          </v-card-title>
          <v-card-text>
              <v-dialog v-model="updatePaymentDetailsDialog" persistent max-width="380" eager>
                <v-card>
                  <v-card-title class="justify-space-between">
                    Update Payment Method
                    <v-btn fab text small @click="updatePaymentDetailsDialog = false"
                      ><v-icon class="text-right text--secondary">close</v-icon></v-btn
                    >
                  </v-card-title>
                  <v-card-text>
                    <div class="mt-4 py-5 px-2" style="border:1px solid #9E9E9E; border-radius: 8px;">
                      <div ref="cardElement"></div>
                    </div>
                    <div class="text-caption error--text">
                      {{ cardError }}
                    </div>
                    <v-row class="pb-0">
                      <v-col class="pt-5 pb-0">
                        <v-btn large elevation="0" color="primary" block @click="addNewPaymentMethod">
                          Update
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-dialog>
              <v-dialog v-model="loadingDialog" persistent width="300">
                <v-card color="primary" dark>
                  <v-card-text>
                    {{ loadingMessage }}
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                  </v-card-text>
                </v-card>
              </v-dialog>
            <p class="ml-3" v-if="businessProfile.lastFour != undefined && businessProfile.lastFour != ''">
              <v-chip class="ma-1" label dark>
                {{ businessProfile.paymentMethod.toUpperCase() }}
              </v-chip>
              <v-icon>more_horiz</v-icon>
              <v-icon>more_horiz</v-icon>
              <v-icon>more_horiz</v-icon> <span class="text-subtitle-1">{{ businessProfile.lastFour }}</span>
              <v-btn text small class="ml-5" fab dark color="primary">
                <v-icon dark @click="updatePaymentDetailsDialog = true">mdi-pencil</v-icon>
              </v-btn>
            </p>
            <p v-else>
              <v-btn color="primary" text @click="updatePaymentDetailsDialog = true">+ Add Payment Method</v-btn>
            </p>
            <v-divider />
            <v-list class="py-0">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="text-subtitle-1">Next Charge</v-list-item-title>
                  <v-list-item-subtitle class="text-subtitle-1 mt-2">
                    $ {{ businessProfile.nextInvoiceAmount / 100 }}
                    <sup><span class="text-caption">AUD</span></sup> (tax inclusive) on
                    {{ formatDate(businessProfile.nextInvoiceCreationDate.toDate())
                    }}<router-link class="ml-5" to="/manageSubscription">Manage Subscription</router-link>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col> -->
      <v-col cols="12">
        <v-card outlined>
          <v-card-title> Billing History </v-card-title>
          <!-- <v-card-subtitle>
                        Looks like you are new here! You have no billing history.
                    </v-card-subtitle> -->
          <v-card-text>
            <v-simple-table v-if="invoices.length > 0">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Date</th>
                    <th class="text-left">Description</th>
                    <th class="text-left">Status</th>
                    <th class="text-left">Service Period</th>
                    <th class="text-left">Total</th>
                    <th class="text-left">Invoice</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="invoice in invoices" :key="invoice.id">
                    <td>
                      {{ formatDate2(new Date(invoice.creationDate * 1000)) }}
                    </td>
                    <!-- <td>{{planName}} Plan</td> -->
                    <td>{{ invoice.description }}</td>
                    <td>
                      <v-chip pill small label class="info accent--text">
                        {{
                          invoice.status.charAt(0).toUpperCase() +
                          invoice.status.slice(1)
                        }}
                      </v-chip>
                    </td>
                    <td
                      v-if="invoice.serviceStartDate == invoice.serviceEndDate"
                    >
                      N/A
                    </td>
                    <td v-else>
                      {{
                        formatDate2(new Date(invoice.serviceStartDate * 1000))
                      }}
                      -
                      {{ formatDate2(new Date(invoice.serviceEndDate * 1000)) }}
                    </td>
                    <td>
                      {{ formatCurrency(invoice.currency) }}
                      {{ invoice.total / 100 }}
                    </td>
                    <td>
                      <v-btn
                        text
                        small
                        fab
                        dark
                        color="grey"
                        :href="invoice.pdf"
                        ><v-icon>mdi-download-outline</v-icon></v-btn
                      >
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <p v-else class="text-center mt-5">
              <v-progress-circular
                indeterminate
                color="accent"
              ></v-progress-circular>
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Utility from "@/shared/utility";

let stripe = Stripe(
  process.env.NODE_ENV == "production"
    ? "pk_live_51H57KKAb8fzN3Ilf9WjqI74BNpQmDCLJ5BdPu1XwMVIxjPdpJ21ZWKAIC0c0IOWkiHMcQ8XcWk9222zodr65ujKm00PucB5bqX"
    : "pk_test_51H57KKAb8fzN3IlflYhq2h05V8HKROSO5ZstUVOsHy9X3kmwfUL2x6z52yc67CYdALFdHbItBtiHwcMdKigqnhs800oWdLxtrs"
);
let elements = stripe.elements();
let cardElement = elements.create("card");
import AccessDeniedCard from "@/components/AccessDeniedCard";
import {getHttpsCallable} from "@/shared/firebase_utils";

export default {
  name: "ManageBilling",
  components: {
    AccessDeniedCard,
  },
  created() {
    this.formatDate = Utility.formatDate;
    this.getSubscriptionPlanTitle = Utility.getSubscriptionPlanTitle;
    this.getInvoices();
  },
  mounted() {
    cardElement.mount(this.$refs.cardElement);
    cardElement.on("change", (event) => {
      this.showCardError(event);
    });
  },
  data() {
    return {
      loadingDialog: false,
      loadingMessage: "",
      cardError: "",
      updatePaymentDetailsDialog: false,
      invoices: [],
      breadcrumbItems: [
        {
          text: "Home",
          disabled: false,
          to: "/",
        },
        {
          text: "Subscription",
          disabled: false,
          to: "/manageSubscription",
        },
        {
          text: "Manage Billing",
          disabled: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["businessProfile", "currentPermission"]),
    planName() {
      return this.getSubscriptionPlanTitle(this.businessProfile.plan);
    },
  },
  methods: {
    ...mapActions(["updateBusinessProfileDetails"]),
    showCardError(event) {
      if (event.error) {
        this.cardError = event.error.message;
      } else {
        this.cardError = "";
      }
    },

    addNewPaymentMethod() {
      this.loadingMessage = "Saving your new payment details...";
      this.loadingDialog = true;
      stripe
        .createPaymentMethod({
          type: "card",
          card: cardElement,
        })
        .then((result) => {
          if (result.error) {
            this.cardError = error;
            this.loadingDialog = false;
          } else {
            this.updatePaymentDetails(result.paymentMethod);
          }
        })
        .catch(() => {
          this.loadingDialog = false;
        });
    },

    async updatePaymentDetails(paymentMethod) {
      //Call a cloud function to attach the payment method to the stripe customer
      try {
        const updatePaymentDetails = getHttpsCallable("updatePaymentDetails");
        let response = await updatePaymentDetails({
          stripeCustomerId: this.businessProfile.stripeCustomerId,
          paymentMethodId: paymentMethod.id,
        });
        if (response.data.error != undefined) {
          this.cardError = response.data.error.message;
          this.loadingDialog = false;
        } else {
          //Done
          if (response.data.successfully) {
            //Update the Business Profile with the new card details
            await this.updateBusinessProfileDetails({
              lastFour: paymentMethod.card.last4,
              paymentMethod: paymentMethod.card.brand,
              paymentMethodExp:
                paymentMethod.card.exp_month +
                "/" +
                paymentMethod.card.exp_year,
            });
            this.loadingDialog = false;
            this.updatePaymentDetailsDialog = false;
          }
        }
      } catch (error) {
        this.cardError = error;
        this.loadingDialog = false;
      }
    },
    formatCurrency(currency) {
      if (currency == "aud" || currency == "usd") return "$";
    },
    formatDate2(date) {
      var dd = String(date.getDate()).padStart(2, "0");
      var mm = String(date.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = date.getFullYear();
      return dd + "/" + mm + "/" + yyyy;
    },
    async getInvoices() {
      try {
        const getInvoicesFromStripe = getHttpsCallable("getInvoicesFromStripe");
        let response = await getInvoicesFromStripe({
          stripeCustomerId: this.businessProfile.stripeCustomerId,
        });
        if (response.data.error != undefined) {
          console.log(response.data.error.message);
        } else {
          // console.log('getInvoicesFromStripe response:');
          // console.log(response.data.data);
          this.invoices = response.data.data.map((invoice) => ({
            id: invoice.id,
            description: invoice.lines.data[0].description,
            pdf: invoice.invoice_pdf,
            serviceStartDate: invoice.lines.data[0].period.start,
            serviceEndDate: invoice.lines.data[0].period.end,
            creationDate: invoice.created,
            total: invoice.total,
            currency: invoice.currency,
            status: invoice.status,
          }));
          console.log("invoices: ", response.data.data);
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
